module.exports = __webpack_public_path__ + "media/tags/smartsearch/checkbox_t-573d4ec152704ef0f7560c7ed92be93a.png";